import { view } from '@yola/ws-sdk';

const getPageContainer = (selector) => {
  const liveDocument = view.accessors.getLiveDocument();

  return liveDocument.querySelector(selector) || liveDocument.body;
};

export default getPageContainer;
